import React, { useState, useEffect } from "react";
import { message } from "antd";
import CloseBankAccount from "../../../../../../components/bankAccount/closeBankAccount";
import DownloadStatement from "./downloadStatement";
import DownloadVerificationDoc from "./downloadVerificationDoc";
import ACHDetailsDownloadDocument from "../../../../../../components/bankAccount/achDetailsDoc/achDetailsDoc";
import EditBankAccount from "../../../../../../components/bankAccount/editBankAccount";
import GenericDeleteModal from "../../../../../../components/buttons/genericDeleteModal";
import GenericDropdown from "../../../../../../components/generic/genericDropdown";
import MarkClosed from "../../closedAccounts/markClosed";

function ConnectedAccountsRowDropdown(props) {

  const [hasStatements, setHasStatements] = useState(props.hasStatements || false)
  const [hasVerificationDocument, setHasVerificationDocument] = useState(props.hasVerificationDocument || false)
  const [isClosable, setIsClosable] = useState(props.isClosable || false)
  const [hasACHDetailsDocument, setHasACHDetailsDocument] = useState(props.hasACHDetailsDocument || false)
  const [dropdownItems, setDropdownItems] = useState([])

  useEffect(() => {
    setHasStatements(props.hasStatements || false)
    setHasVerificationDocument(props.hasVerificationDocument || false)
    setIsClosable(props.isClosable || false)
    setHasACHDetailsDocument(props.hasACHDetailsDocument || false)
  }, [props]);

  useEffect(() => {
    let newDropdownItems = []
    if (hasStatements) {
      newDropdownItems.push(<DownloadStatement record={props.record} />)
    }

    if (hasVerificationDocument) {
      newDropdownItems.push(<DownloadVerificationDoc record={props.record} />)
    };

    if (isClosable) {
      newDropdownItems.push(<CloseBankAccount
        buttonView={false}
        bankAccountId={props.record.id}
        bankInfo={props.record}
      />)
    };

      newDropdownItems.push(<MarkClosed 
        markedClosed={props.markedClosed}
        bankAccountId={props.record.id}
        setClosedAccounts={props.setClosedAccounts}
        setConnectedAccounts={props.setConnectedAccounts}
        record={props.record}
      />);

    if (hasACHDetailsDocument) {
      newDropdownItems.push(
        <ACHDetailsDownloadDocument
          bankAccountId={props.record.id}
          beneficiaryName={props.record.beneficiary.name}
          beneficiaryAddress={props.record.beneficiary.address}
          accountTyipe={props.record.account.account_type}
          bankName={props.record.account.bank?.name}
          bankAddress={props.record.account.bank_address}
          displayMessage={"Download ACH/Wire Details"}
          buttonView={false}
        />
      )
    };

    newDropdownItems.push(
      <EditBankAccount
        buttonView={false}
        source={props.record.account.account_source}
        accountId={props.record.id}
        accountPurposeName={props.record.purpose.name}
        accountPurposeId={props.record.purpose.id}
        accountGenericTags={props.record.generic_tags}
        institutionName={props.record.account.bank?.name}
        accountDescription={props.record.description}
        entityName={props.record.entity_name}
        onSuccessReassign={props.reassignBankAccount}
        onSuccessRename={props.editBankAccount}
        subPortfolioId={props.record.portfolioId}
        propertyId={props.record.propertyId}
        subPortfolioName={props.record.portfolio}
        propertyName={props.record.property}
        myAccountsPage={true}
      />
    );

    newDropdownItems.push(
      <GenericDeleteModal
        type='Bank Account'
        title={`Are you sure you want to delete ${props.record.description}?`}
        URL='/api/bank-account/'
        deleteParams={{ 'account_id': props.record.id, 'purpose_id': props.record.purpose.id }}
        description={`By clicking Delete below you will no longer have the bank account ${props.record.description} on your dashboard. If you do not want to proceed or unsure, please click X on the upper right.`}
        handleDeleteSuccess={() => props.deleteBankAccount(props.record.id)}
        handleDeleteFailure={() => message.error(`Failed to delete the bank account ${props.record.description}`)}
      />
    );

    setDropdownItems(newDropdownItems)

  }, [hasStatements, hasVerificationDocument, isClosable, hasACHDetailsDocument, props.record])

  return (
    <GenericDropdown dropdownItems={dropdownItems} />
  );
}

export default ConnectedAccountsRowDropdown